import * as RadixCheckbox from '@radix-ui/react-checkbox';
import checkedIcon from '../assets/checked.svg';

const Checkbox = ({ checked, onCheckedChange, disabled, size = 5, ...props }) => {
  if (disabled) {
    return (
      <div 
        className={`Checkbox w-${size} h-${size} relative bg-[#eeeeee] rounded-[48px] border border-[#dddddd]`} 
      />
    );
  }

  return (
    <RadixCheckbox.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={`w-${size} h-${size} relative rounded-xl ${
        checked 
          ? 'bg-white border-b border-[#eeeeee]' 
          : 'bg-white rounded-[47px] border border-[#dddddd]'
      }`}
      {...props}
    >
      <RadixCheckbox.Indicator>
        {checked && (
          <img src={checkedIcon} alt="checked" className={`w-${size} h-${size}`} />
        )}
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  );
};

export default Checkbox; 